import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  "element-loading-text": "正在提交数据，请稍后",
  style: {"min-height":"500px"}
}
const _hoisted_2 = /*#__PURE__*/_createTextVNode("保存")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("取消")

import { ref, reactive, unref } from 'vue';

/* Npm Plugins */
import { ElForm, FormRules, ElMessage } from 'element-plus';

/* Plugins */
import { GbDialog } from '@/components/GbDialog/Index';
import ContactList from './ContactList.vue';
// import BankList from './bankList.vue'

/* Types */
import type { CounterparCreate } from '../../../apis/counterpart/counterpart.type';
import { CpCreateApi } from '../../../apis/counterpart/counterpart.api';


export default /*#__PURE__*/_defineComponent({
  emits: ['onCreated'],
  setup(__props, { expose, emit }) {

const loading = ref<boolean>(false);
const showDialog = ref<boolean>(false);

/*表单验证 */
const rules = reactive<FormRules>({
	no: [{ required: true, message: '编号不能留空', trigger: 'blur' }],
	name: [{ required: true, message: '名称不能留空', trigger: 'blur' }],
	part_type_id: [{ required: true, message: '请选择纳税人资质', trigger: 'blur' }],
	pay_taxes: [{ required: true, message: '请选择相对方类型', trigger: 'blur' }],
	code: [{ required: true, message: '统一社会信用代码不能留空', trigger: 'blur' }],
	country: [{ required: true, message: '所在国家不能留空', trigger: 'blur' }],
	province: [{ required: true, message: '所在省份/州不能留空', trigger: 'blur' }],
	address: [{ required: true, message: '地址不能留空', trigger: 'blur' }],
});

const elFormRef = ref<ComponentRef<typeof ElForm>>();
const contactRef = ref<ComponentRef<typeof ContactList>>();
// const bankRef = ref<ComponentRef<typeof BankList>>()

const formSchema = ref<CounterparCreate>({
	part_type_id: '',
	no: '',
	short_name: '',
	code: '',
	name: '',
	address: '',
	phone: '',
	contract: '',
	contract_num: '',
	country: '',
	province: '',
	pay_taxes: '',
	is_enabled: 'Y',
});

/* 保存 */
const onCreateBtnClick = () => {
	unref(elFormRef)?.validate((isValid: boolean) => {
		if (!isValid) return;

		loading.value = true;

		const contractList = unref(contactRef)?.expMethods.getContactList();
		// const bankList = unref(bankRef)?.expMethods.getBankList();

		/* 至少需要一个收款银行记录 */
		// if ((bankList?.length || 0) <= 0) {
		// 	ElMessage.warning(`未设置相对方收款银行信息，至少需要设置一笔收款银行记录。`);
		// 	return;
		// }

		const savedata = unref(formSchema);

		savedata.contact_list = contractList;
		// savedata.bank_list = bankList;

		/* 保存数据 */
		CpCreateApi(savedata).then((res) => {
			if (!res.succeeded) {
				ElMessage.error(`保存数据出错，可能的原因是：${res.errors}`);

				loading.value = false;
			} else {
				ElMessage.success('保存成功。');

				/* 为什么会有这段代码？这是在营造一种：“前端我啊，在努力工作呢”的感觉，毕竟闪太快会给别人觉得有问题 */
				setTimeout(() => {
					emit('onCreated', res.data);

					loading.value = false;

					showDialog.value = false;
				}, 1000);
			}
		});
	});
};

/* 暴露出去的属性&方法 */
const methods: {
	showCpDialog: () => void;
	closeCpDialog: () => void;
} = {
	showCpDialog: () => {
		showDialog.value = true;
	},
	closeCpDialog: () => {
		showDialog.value = false;
	},
};

expose({ methods });



return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_button = _resolveComponent("el-button")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_unref(GbDialog), {
    modelValue: showDialog.value,
    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((showDialog).value = $event)),
    title: "新增相对方",
    style: {"width":"1366px"}
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_el_button, {
        type: "primary",
        disabled: loading.value,
        onClick: onCreateBtnClick
      }, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      }, 8, ["disabled"]),
      _createVNode(_component_el_button, {
        type: "info",
        disabled: loading.value,
        onClick: _cache[15] || (_cache[15] = ($event: any) => (showDialog.value = false))
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }, 8, ["disabled"])
    ]),
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_el_tabs, { type: "border-card" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_tab_pane, { label: "基础资料" }, {
              default: _withCtx(() => [
                _createVNode(_unref(ElForm), {
                  ref_key: "elFormRef",
                  ref: elFormRef,
                  model: formSchema.value,
                  "label-width": "120px",
                  "label-position": 'top',
                  rules: _unref(rules),
                  style: {"padding":"20px 40px"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_row, { gutter: 20 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_col, { span: 6 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_form_item, {
                              label: "编号",
                              prop: "no"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: formSchema.value.no,
                                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formSchema.value.no) = $event)),
                                  placeholder: "请输入相对方编号"
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_col, { span: 6 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_form_item, {
                              label: "名称",
                              prop: "name"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: formSchema.value.name,
                                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formSchema.value.name) = $event)),
                                  placeholder: "请输入相对方名称"
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_col, { span: 6 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_form_item, {
                              label: "简称",
                              prop: "short_name"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: formSchema.value.short_name,
                                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formSchema.value.short_name) = $event)),
                                  placeholder: "请输入相对方简称"
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_col, { span: 6 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_form_item, {
                              label: "类型",
                              prop: "part_type_id"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_select, {
                                  style: {"width":"100%"},
                                  modelValue: formSchema.value.part_type_id,
                                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formSchema.value.part_type_id) = $event)),
                                  placeholder: "请选择相对方类型"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_option, {
                                      label: "内部单位",
                                      value: "1"
                                    }),
                                    _createVNode(_component_el_option, {
                                      label: "供应商",
                                      value: "2"
                                    }),
                                    _createVNode(_component_el_option, {
                                      label: "客户",
                                      value: "3"
                                    }),
                                    _createVNode(_component_el_option, {
                                      label: "合作伙伴",
                                      value: "4"
                                    }),
                                    _createVNode(_component_el_option, {
                                      label: "其他",
                                      value: "99"
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_row, { gutter: 20 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_col, { span: 6 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_form_item, {
                              label: "手机/固话",
                              prop: "phone"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: formSchema.value.phone,
                                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formSchema.value.phone) = $event)),
                                  placeholder: "请输入手机/固话"
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_col, { span: 6 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_form_item, {
                              label: "法人姓名",
                              prop: "contract"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: formSchema.value.contract,
                                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formSchema.value.contract) = $event)),
                                  placeholder: "请输入联系人"
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_col, { span: 6 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_form_item, {
                              label: "法人联系方式",
                              prop: "contract_num"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: formSchema.value.contract_num,
                                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formSchema.value.contract_num) = $event)),
                                  placeholder: "请输入联系人电话"
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_col, { span: 6 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_form_item, {
                              label: "统一社会信用代码",
                              prop: "code"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: formSchema.value.code,
                                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formSchema.value.code) = $event)),
                                  placeholder: "请输入统一社会信用代码"
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_row, { gutter: 20 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_col, { span: 6 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_form_item, {
                              label: "国家",
                              prop: "country"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: formSchema.value.country,
                                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((formSchema.value.country) = $event)),
                                  placeholder: "请输入国籍"
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_col, { span: 6 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_form_item, {
                              label: "省份/州",
                              prop: "province"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: formSchema.value.province,
                                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((formSchema.value.province) = $event)),
                                  placeholder: "请输入地区"
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_col, { span: 12 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_form_item, {
                              label: "地址",
                              prop: "address"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: formSchema.value.address,
                                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((formSchema.value.address) = $event)),
                                  placeholder: "请输入地址"
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_row, { gutter: 20 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_col, { span: 6 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_form_item, { label: "纳税人资质" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_select, {
                                  modelValue: formSchema.value.pay_taxes,
                                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((formSchema.value.pay_taxes) = $event)),
                                  style: {"width":"100%"}
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_option, {
                                      label: "增值税一般纳税人",
                                      value: "1"
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_col, { span: 6 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_form_item, { label: "发票抬头" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: formSchema.value.invoice_title,
                                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((formSchema.value.invoice_title) = $event)),
                                  placeholder: "请录入发票抬头"
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_col, { span: 12 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_form_item, { label: "开票地址" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: formSchema.value.invoice_address,
                                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((formSchema.value.invoice_address) = $event)),
                                  placeholder: "请录入开票地址"
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_row, { gutter: 20 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_col, { span: 24 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_form_item, { label: "备注" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_input, {
                                  type: "textarea",
                                  modelValue: formSchema.value.remark,
                                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((formSchema.value.remark) = $event)),
                                  rows: "2",
                                  "show-word-limit": "",
                                  maxlength: "150"
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["model", "rules"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_tab_pane, { label: "联系人" }, {
              default: _withCtx(() => [
                _createVNode(ContactList, {
                  ref_key: "contactRef",
                  ref: contactRef
                }, null, 512)
              ]),
              _: 1
            }),
            _createVNode(_component_el_tab_pane, { label: "银行信息" })
          ]),
          _: 1
        })
      ])), [
        [_directive_loading, loading.value]
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})